<template>
  <section class="static-pages">
    <v-container>
      <div class="__bread mt-5">
        <v-breadcrumbs :items="Bread"></v-breadcrumbs>
      </div>
      <div class="content" v-if="pageDetails.id">
        <h3> {{ pageDetails.title }} </h3>
        <hr/>
        <p v-html="pageDetails.body"></p>
      </div>
      <div v-else>
        <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
        <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
        <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
        <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
        <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
      </div>
    </v-container>
  </section>
</template>

<script>
import {mapGetters} from "vuex";
import NoData from "../no-data.vue";
import axios from "axios";
import router from "@/router";

export default {
  components: {
    NoData,
  },
  data() {
    return {
      pageDetails: {
        id: 0,
        title: '-----',
        body: '',
      },
    };
  },
  computed: {
    ...mapGetters("home", ["getFixedPageDetails"]),
    Bread() {
      return [
        {
          text: this.$t("Breadcrumb.home"),
          disabled: false,
          to: "/",
        },
        {
          text: this.pageDetails?.title ?? '-----',
          disabled: true,
          to: "",
        }
      ];
    }
  },
  async mounted() {
    let slug = this.$route.params.slug;
    await this.getPageDetails(slug);
  },
  methods: {
    getPageDetails(slug) {
      this.pageDetails = {
        id: 0,
        title: '-----',
        body: '',
      };

      if (!slug) return;
      let cleanSlug = slug;
      try {
        cleanSlug = decodeURIComponent(slug);
      } catch (e) {
        cleanSlug = slug;
      }

      axios.get('fixed-pages/' + cleanSlug)
          .then(response => {
            this.pageDetails = response.data.data;
          })
          .catch(() => {
            this.$router.push({name: "NotFound"});
          });
    }
  },
  watch: {
    async $route(to, from) {
      if (to.params.slug !== from.params.slug) {
        await this.getPageDetails(to.params.slug);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.static-pages {
  height: 100%;
  background-color: #fafafa;
  padding: 50px 0;
  @media (max-width: 767px) {
    padding: 40px 0;
  }

  .__bread {
    box-shadow: none !important;

    .v-breadcrumbs {
      background: #ffffff 0 0 no-repeat padding-box;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      font-size: 14px;
      box-shadow: none !important;
      padding: 12px;
    }

    .v-breadcrumbs__item {
      color: #000 !important;
    }

    .v-breadcrumbs__item--disabled {
      color: #868e96 !important;
    }
  }

  .content {
    margin-top: 48px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;

    h3 {
      font-weight: bold;
      margin-top: 5px;
      color: #4d4d4d;
    }

    p {
      line-height: 1.8;
      color: #4d4d4d;
      text-align: start;
    }

    hr {
      height: 5px;
      color: #e0e0e0;
      width: 100%;
    }
  }
}
</style>
